export default function App() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-primary-500 via-primary-600 to-accent-600 rounded-3xl overflow-hidden">
            <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 p-8 md:p-12">
              <div className="flex-1 text-center lg:text-left">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50">
                  随时随地，畅享漫画
                </h2>
                <p className="mt-4 text-sm md:text-base text-background-100/90 leading-relaxed">
                  香香漫画全面适配手机、平板、电脑等各类设备。无论你是在通勤路上、午休时光还是居家放松，打开香香漫画网址即可享受下拉式追更的畅快体验。无需下载安装，打开浏览器就能开始阅读好看的漫画免费全集。
                </p>
                <p className="mt-3 text-sm text-background-200 leading-relaxed">
                  支持 iOS、Android 等主流系统，跨设备同步阅读进度，追更更方便。推荐使用手机浏览器访问香香漫画官网入口，获得最佳移动端阅读体验。
                </p>
                <div className="mt-6 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                  <a
                    href="#hero"
                    className="inline-flex items-center gap-2 px-8 py-3 bg-background-50 text-primary-600 font-semibold rounded-full hover:bg-background-100 transition-colors text-sm whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-smartphone-line text-lg" />
                    立即开始阅读
                  </a>
                  <a
                    href="#features"
                    className="inline-flex items-center gap-2 px-8 py-3 border-2 border-background-200/40 text-background-50 font-semibold rounded-full hover:bg-background-50/10 transition-colors text-sm whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-information-line text-lg" />
                    了解平台优势
                  </a>
                </div>
              </div>

              <div className="shrink-0 w-56 md:w-64">
                <div className="relative">
                  <div className="absolute inset-0 bg-background-50/10 rounded-3xl blur-xl" />
                  <div className="relative bg-background-50 rounded-2xl shadow-lg overflow-hidden p-2">
                    <img
                      src="https://readdy.ai/api/search-image?query=A%20clean%20smartphone%20mockup%20displaying%20a%20manga%20reading%20app%20interface%20with%20scrolling%20comic%20content%20on%20screen%2C%20warm%20cream%20and%20peach%20background%2C%20minimal%20modern%20UI%20design%2C%20soft%20lighting%2C%20clean%20stylized%20illustration%2C%20harmonious%20composition&width=600&height=1200&seq=app-mobile-mockup&orientation=portrait"
                      alt="香香漫画移动端阅读 - 下拉式追更，手机随时随地免费看漫画"
                      className="w-full h-auto rounded-xl"
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}